@if (checkUploadProgressStatus()) {
  <div class="popup-container">
    <div class="popup-block">
      <div class="popup-header">
        <div class="close-btn" (click)="cancelUpload()"></div>
      </div>
      <div class="popup-body">
        @if (uploadProgressAction.status === 'start') {
          <div class="upload-description-block">
            <label for="assetDescription" class="upload-description-label">
              Description <span class="required-asterisk">*</span>
            </label>
            <textarea
              id="assetDescription"
              class="upload-description-input"
              name="assetDescription"
              [(ngModel)]="description"
              [maxlength]="maxDescriptionLength"
              rows="2"
              placeholder="Enter a description for this media (required)"
            ></textarea>
            <div class="upload-description-meta">
              <span class="upload-description-count">{{ description.length }}/{{ maxDescriptionLength }}</span>
            </div>
          </div>
          <div
            class="upload-block"
            (drop)="dropFiles($event)"
            (dragover)="dragOverHandler($event)"
            >
            <img src='../../../../../assets/svg/upload-cloud.svg' alt="" class="upload-image" />
            <h4 class="upload-header">Drag and drop your file here.</h4>
            <p class="upload-info line">or</p>
            <input
              type="file"
              #fileUpload
              id="fileUpload"
              name="fileUpload"
              style="display: none"
              accept=".pdf, .doc, .ppt, .xls, .docx, .pptx, .xlsx, .jpg, .jpeg, .png, .svg, .aac, .mp4, .amr, .mp3, .opus"
              />
              <button class="upload-asset-btn" (click)="uploadFileHandler()">browse files</button>
              <p class="upload-info">
                Only PDF, DOC, PPT, XLS, JPG, JPEG, PNG, SVG, AAC, MP4, AMR, MP3, OPUS with a max file
                size of 100 MB.
              </p>
              <p class="upload-info">You can only upload 1 file at a time.</p>
            </div>
          }
          @if (uploadProgressAction.status === 'progress') {
            <div class="upload-progress-block">
              <div class="upload-start">
                <img src='../../../../../assets/svg/file-png.svg' alt="" class="upload-image" />
                <div class="upload-progress-info-block">
                  <div class="upload-info-top">
                    <div class="upload-file-info">
                      <h5 matTooltipClass="assetTooltip" #tt="matTooltip" appTruncateWithTooltip matTooltipPosition="above"
                      [matTip]="tt" tooltipText="'{{uploadProgressAction.item.name}}'" [allowedTextLength]="50" matTooltip=""></h5>
                      <p>
                        {{ uploadProgressAction.size
                        }}@if (uploadProgressAction.progress < 1) {
                        <span>not started</span>
                      }
                    </p>
                  </div>
                  <div class="upload-progress-status">
                    {{ uploadProgressAction.progress }}%
                    <button class="close-btn" (click)="cancelUpload()"></button>
                  </div>
                </div>
                <mat-progress-bar
                  mode="determinate"
                  [value]="uploadProgressAction.progress"
                ></mat-progress-bar>
              </div>
            </div>
          </div>
        }
        @if (uploadProgressAction.status === 'cancel') {
          <div class="upload-cancel">
            <h4 class="cancel-title">Uploading in progress. Are you sure you want to cancel?</h4>
            <div class="buttons-block">
              <button class="cancel-btn" (click)="continueUploadHandler()">Nevermind</button>
              <button class="delete-btn" (click)="cancelUploadHandler()">Cancel</button>
            </div>
          </div>
        }
      </div>
    </div>
  </div>
}
